import { createAction } from "~/utils/actions";

export default {
	...createAction("CLOSE_EKSTRA_INNBETALING_MESSAGE"),
	...createAction("CLOSE_AVKASTNINGSHISTORIKK"),
};
